import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const trendRTK = createApi({
  reducerPath: "trend_slice",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: [
    "bondScoreTrend",
    "ghostConsumersTrend",
    "missingRevenueTrend",
    "opportunitiesTrend",
    "secondaryConsumersTrend",
  ],
  endpoints: (build) => ({
    getBondScoreTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/bond_score/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["bondScoreTrend"],
    }),
    getGhostConsumersTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/ghost_consumer/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["ghostConsumersTrend"],
    }),
    getMissingRevenueTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_revenue/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["missingRevenueTrend"],
    }),
    getOpportunitiesTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/opportunities/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["opportunitiesTrend"],
    }),
    getDepositsTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/primary_consumer/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["depositsTrend"],
    }),
  }),
});